/**
 * Frontend types for the pillar-6 MCP correction taxonomy.
 *
 * The Postgres enum `public.mcp_correction_category` (migration
 * 20260507000001) is the authoritative source for these values. The
 * constant below must agree with both the SQL enum AND
 * `mcp/core/types.ts → MCP_CORRECTION_CATEGORIES`. Agreement is pinned by
 * `src/lib/serverContracts/mcpCorrectionTaxonomy.test.ts`.
 */

export const MCP_CORRECTION_CATEGORIES = [
  'INVENTED_DATA',
  'TENANT_SCOPE_RISK',
  'AUDIT_FAILURE',
  'UNSAFE_MUTATION',
  'UNSUPPORTED_STATUS_CLAIM',
  'SIGNED_URL_EXPOSURE',
  'TRACKER_MISMATCH',
  'ENV_CONTRACT_MISMATCH',
] as const

export type McpCorrectionCategory = typeof MCP_CORRECTION_CATEGORIES[number]

/**
 * Human-readable label per category. Used in dropdowns and badges. Kept
 * in this file so the label set lives next to the canonical values.
 */
export const CATEGORY_LABEL: Readonly<Record<McpCorrectionCategory, string>> = {
  INVENTED_DATA:            'Invented data',
  TENANT_SCOPE_RISK:        'Tenant-scope risk',
  AUDIT_FAILURE:            'Audit failure',
  UNSAFE_MUTATION:          'Unsafe mutation',
  UNSUPPORTED_STATUS_CLAIM: 'Unsupported status claim',
  SIGNED_URL_EXPOSURE:      'Signed-URL exposure',
  TRACKER_MISMATCH:         'Tracker mismatch',
  ENV_CONTRACT_MISMATCH:    'Env contract mismatch',
}

export interface MCPCorrectionRow {
  id:               string
  organization_id:  string
  server_name:      string
  tool_name:        string
  category:         McpCorrectionCategory
  reason:           string | null
  reported_by:      string | null
  created_at:       string
  is_active:        boolean
}
